import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const pageModules = import.meta.env.SSR
  ? import.meta.glob('./pages/*.jsx', { eager: true })
  : import.meta.glob('./pages/*.jsx');

const pageCache = new Map();

function getPageComponent(fileName) {
  if (pageCache.has(fileName)) {
    return pageCache.get(fileName);
  }

  const modulePath = `./pages/${fileName}`;
  const pageModule = pageModules[modulePath];

  if (!pageModule) {
    throw new Error(`No se encontró la página ${fileName}`);
  }

  const component = import.meta.env.SSR
    ? pageModule.default
    : lazy(pageModule);

  pageCache.set(fileName, component);
  return component;
}

const HomePage = getPageComponent('HomePage.jsx');
const NosotrasPage = getPageComponent('NosotrasPage.jsx');
const ConsultoriasPage = getPageComponent('ConsultoriasPage.jsx');
const CursosPage = getPageComponent('CursosPage.jsx');
const ContactoPage = getPageComponent('ContactoPage.jsx');
const BlogPage = getPageComponent('BlogPage.jsx');
const InfoPage = getPageComponent('InfoPage.jsx');
const PodcastPage = getPageComponent('PodcastPage.jsx');
const CourseLandingPage = getPageComponent('CourseLandingPage.jsx');
const Curso0a4MesesPage = getPageComponent('Curso0a4MesesPage.jsx');
const Curso4a20MesesPage = getPageComponent('Curso4a20MesesPage.jsx');
const DesteteNocturnoPage = getPageComponent('DesteteNocturnoPage.jsx');
const LoQueNecesitasSaberPage = getPageComponent('LoQueNecesitasSaberPage.jsx');
const PrimerosAlimentosPage = getPageComponent('PrimerosAlimentosPage.jsx');
const CombosPage = getPageComponent('CombosPage.jsx');

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/nosotras" element={<NosotrasPage />} />
      <Route path="/consultorias" element={<ConsultoriasPage />} />
      <Route path="/cursos" element={<CursosPage />} />
      <Route path="/cursos/0-4-meses" element={<Curso0a4MesesPage />} />
      <Route path="/cursos/4-20-meses" element={<Curso4a20MesesPage />} />
      <Route path="/cursos/destete-nocturno" element={<DesteteNocturnoPage />} />
      <Route path="/cursos/lo-que-necesitamos-saber" element={<LoQueNecesitasSaberPage />} />
      <Route path="/cursos/primeros-alimentos" element={<PrimerosAlimentosPage />} />
      <Route path="/cursos/combos" element={<CombosPage />} />
      <Route path="/combos" element={<CombosPage />} />
      <Route path="/cursos/:slug" element={<CourseLandingPage />} />
      <Route path="/contacto" element={<ContactoPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPage />} />
      <Route path="/podcast" element={<PodcastPage />} />
      <Route path="/privacidad" element={<InfoPage type="privacidad" />} />
      <Route path="/terminos-y-condiciones" element={<InfoPage type="terminos" />} />
      <Route path="/terminos" element={<InfoPage type="terminos" />} />
      <Route path="/preguntas-frecuentes" element={<InfoPage type="faq" />} />
    </Routes>
  );
}

export default AppRoutes;
